var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6175 50.7999C10.3626 45.5721 7.62709 37.2497 12.3372 28.415C12.6477 27.8327 13.571 28.0385 13.7634 28.6697C14.4504 30.9245 15.8435 32.0501 15.8435 32.0501C15.4004 31.0277 13.677 19.9877 21.992 14.9106C22.4762 14.6149 23.068 15.0525 22.9928 15.6146C22.6145 18.4416 22.3324 24.5086 27.2513 22.8052C31.7133 21.2599 28.5066 13.1853 26.8664 9.68253C26.5996 9.11293 27.1696 8.48055 27.7522 8.71846C37.6358 12.755 45.3687 19.3376 42.5751 31.2559C43.3118 31.3941 45.7287 30.9723 47.1 28.9919C47.4584 28.474 48.2847 28.4507 48.4638 29.0544C49.8205 33.6274 51.8351 45.6414 41.0647 52.0003C40.4571 50.4734 39.2813 49.3208 38.8358 48.9574C38.7247 48.8665 38.6187 48.8981 38.5331 49.0132C38.1113 49.5814 36.6969 51.3445 35.3104 51.4517C32.7511 51.649 31.3243 48.8683 31.9505 45.8368C32.0211 45.4952 31.7152 45.1759 31.3828 45.2828C27.3505 46.5819 26.2999 49.2625 26.2999 49.2625C24.5545 47.8437 23.0104 45.217 23.3374 39.2477C23.362 38.7992 22.8025 38.587 22.5524 38.9601C20.9706 41.3197 17.8559 46.4748 17.6175 50.7999Z",
    fill: "url(#paint0_linear_5150_3894)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5150_3894",
    x1: 18.7108,
    y1: -11.158,
    x2: 53.5811,
    y2: -0.395752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959671,
    stopColor: "#FF9393"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlame);
export default __webpack_public_path__ + "static/media/flame.b9082d7d1d6db31c2ece98f83e123c02.svg";
export { ForwardRef as ReactComponent };